
export const ScheduleQueueResultCode = {
    positive: "POSITIVE",
    error: "ERROR",
    cancelled: "CANCELLED",
    issue: "ISSUE"
}